import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import MasterData from '../../data/MasterData'

const TrainPositionKindModal = ({ themeName, closeKindModal }) => {
  const intl = useIntl()
  const locale = intl.locale
  const navigate = useNavigate()

  useEffect(() => {
    return () => {
      closeKindModal()
    }
  }, [])

  const handleCloseClick = (e) => {
    navigate(-1)
  }

  return (
    <div className="c-Modal">
      <div className="c-Modal-dialog">
        <div className="c-Modal-header is_default">
          <p className="c-Modal-headerTitle"><FormattedMessage id='App.TrainPositions.kindModal.title' /></p>
          <div className="c-Modal-headerClose" onClick={handleCloseClick}></div>
        </div>
        {/*<!-- MEMO: 種別アイコンカラー
          .is_jr → JR線直通（ミドリ）
          .is_limitedExpress → 特急（オレンジ）
          .is_express → 急行（赤）
          .is_rapid → 快速（水色）
          .is_local → 各停（グレー）
        -->*/}

        <ul className="c-Modal-trainKindList">
        <li className="c-Modal-trainKindItem">
            <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_jr`}>特</span>
            <span>
              {MasterData.trainKindById(0)[`routemap_name_${locale}`]}(
                <FormattedMessage id='App.TrainPositions.thruToJR' values={{br: ''}} />
                )
              </span>
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_toyoko`}>特</span>
              <span>
                {MasterData.trainKindById(0)[`routemap_name_${locale}`]}(
                <FormattedMessage id='App.TrainPositions.thruToToyoko' values={{br: ''}} />
                )
              </span>
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_meguro`}>特</span>
              <span>
                {MasterData.trainKindById(0)[`routemap_name_${locale}`]}(
                <FormattedMessage id='App.TrainPositions.thruToMeguro' values={{br: ''}} />
                )
              </span>
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_limitedExpress`}>特</span>
              {MasterData.trainKindById(0)[`routemap_name_${locale}`]}
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_limitedExpress`}>通</span>
              {MasterData.trainKindById(5)[`routemap_name_${locale}`]}
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_express`}>通</span>
              {MasterData.trainKindById(6)[`routemap_name_${locale}`]}
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_rapid`}>快</span>
              {MasterData.trainKindById(2)[`routemap_name_${locale}`]}
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_jr`}>各</span>
              <span>
                {MasterData.trainKindById(4)[`routemap_name_${locale}`]}(
                <FormattedMessage id='App.TrainPositions.thruToJR' values={{br: ''}} />
                )
              </span>
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_toyoko`}>各</span>
              <span>
                {MasterData.trainKindById(4)[`routemap_name_${locale}`]}(
                <FormattedMessage id='App.TrainPositions.thruToToyoko' values={{br: ''}} />
                )
              </span>
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_meguro`}>各</span>
              <span>
                {MasterData.trainKindById(4)[`routemap_name_${locale}`]}(
                <FormattedMessage id='App.TrainPositions.thruToMeguro' values={{br: ''}} />
                )
              </span>
            </li>
            <li className="c-Modal-trainKindItem">
              <span className={`c-Modal-trainKindIcon c-Modal-trainKindIcon-${locale} is_local`}>各</span>
              {MasterData.trainKindById(4)[`routemap_name_${locale}`]}
            </li>
          </ul>
        </div>
      </div>
    )
}

TrainPositionKindModal.propTypes = {
  themeName: PropTypes.string.isRequired,
  closeKindModal: PropTypes.func.isRequired,
}

export default TrainPositionKindModal
